<template>
  <div class="notfound-page">
    <div class="notfound-inner">
      <div class="art">
        <img :src="img" alt="404 artwork" />
      </div>

      <div class="content">
        <h6 class="muted">Houston</h6>
        <h2 class="title">we have a problem......</h2>

        <div class="big-404">404</div>

        <p class="subtitle">Pagina niet gevonden</p>

        <div class="actions">
          <button class="btn-primary" @click="goHome">
            Ga terug naar de homepage
          </button>
          <button class="btn-secondary" @click="goBack">Terug</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  data() {
    return {
      // Import the image from assets folder - update path if needed
      img: require('@/assets/no-image.png'),
    };
  },
  methods: {
    goHome() {
      this.$router.push({ name: 'Home' }).catch(() => {});
    },
    goBack() {
      if (window.history.length > 1) {
        this.$router.back();
      } else {
        this.goHome();
      }
    },
  },
};
</script>
<style scoped>
.notfound-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: radial-gradient(ellipse at bottom left, #081026 0%, #0f2540 50%, #071224 100%);
  color: #fff;
  padding: 40px 20px;
  box-sizing: border-box;
}

.notfound-inner {
  width: 100%;
  max-width: 1200px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  align-items: center;
}

/* artwork column */
.art {
  display: flex;
  align-items: center;
  justify-content: center;
}
.art img {
  width: 100%;
  max-width: 520px;
  height: auto;
  object-fit: contain;
  filter: drop-shadow(0 6px 20px rgba(0,0,0,0.6));
}

/* content column */
.content {
  padding: 20px 40px;
}
.muted {
  color: #f2c96b;
  font-weight: 600;
  margin-bottom: 6px;
  text-transform: none;
  font-size: 14px;
  opacity: 0.95;
}
.title {
  font-size: 20px;
  margin: 0 0 14px 0;
  color: #ffd27a;
}
.big-404 {
  font-size: 120px;
  font-weight: 800;
  line-height: 1;
  margin: 0 0 12px 0;
  color: #ffffff;
  text-shadow: 0 8px 30px rgba(0,0,0,0.6);
}
.subtitle {
  font-size: 20px;
  margin: 0 0 20px 0;
  color: #ffd27a;
}

/* buttons */
.actions {
  display: flex;
  gap: 12px;
  align-items: center;
}
.btn-primary,
.btn-secondary {
  padding: 10px 18px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
}
.btn-primary {
  background: linear-gradient(90deg, #ffb75e 0%, #f19b3e 100%);
  color: #0b1020;
  box-shadow: 0 6px 18px rgba(241,155,62,0.25);
}
.btn-secondary {
  background: transparent;
  color: #fff;
  border: 1px solid rgba(255,255,255,0.12);
}

/* responsive */
@media (max-width: 900px) {
  .notfound-inner {
    grid-template-columns: 1fr;
    text-align: center;
  }
  .content {
    padding: 20px 10px;
  }
  .art img {
    max-width: 360px;
  }
  .big-404 {
    font-size: 72px;
  }
}
</style>